module.exports = __webpack_public_path__ + "static/img/tool-blue.b270b281.png";